<template>
  <div>
    <main-header></main-header>
    <div id="custom-header" ref="homing">
      <img src="../assets/images/banner/img_banner4.jpg" />
      <div class="custom-header-content">
        <div class="container">
          <h1 class="page-title">HOMING Series</h1>
        </div>
      </div>
    </div>
    <div id="content" class="site-content global-layout-no-sidebar">
      <div class="container">
        <div class="inner-wrapper">
          <div id="primary" class="content-area">
            <div id="main" class="site-main">
              <!-- ABOUT HOMING -->
              <div class="section section-featured-page">
                <div class="container">
                  <div class="inner-wrapper">
                    <div class="featured-page-section">
                      <div class="col-grid-5">
                        <div class="inner-wrapper">
                          <img
                            class="alignnone"
                            alt="About Us"
                            src="../assets/images/homing/1index.png"
                          />
                        </div>
                      </div>
                      <div class="col-grid-7 paddingLeft">
                        <div class="section-title-wrap text-alignleft">
                          <h2 class="section-title">ABOUT HOMING</h2>
                          <span class="divider0"></span>
                          <p>
                            <span class="p_logo">
                              <img
                                src="../assets/images/homing/HomingRed.png"
                              />
                            </span>
                            is the register brand of Pearl River Engineering Pte
                            Ltd and specializing in providing High-end whole
                            house customization service. Like the potential
                            capabilities of the tangram, HOMING is committed to
                            creating infinite possibilities. By looking beyond
                            the convention, constantly seeking new technologies
                            and ideas for breakthrough solution for the home
                            environment.
                          </p>
                        </div>
                        <div class="more" @click="nextHoming">
                          → Explore HOMING.SG
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!--  -->
              <div class="section" style="padding-top: 0">
                <div class="container">
                  <div class="section-title-wrap">
                    <h2 class="section-title">What Does HOMING Have?</h2>
                    <span class="dividerRed"></span>
                  </div>
                </div>
              </div>
              <!-- 图片 -->
              <div class="homing_bg">
                <img src="../assets/images/homing/img_bg.jpg" />
              </div>
              <!-- 文字描述 -->
              <div class="homing_section">
                <div class="container">
                  <div>
                    <div class="col-grid-4 no-margin">
                      <div class="homing_item">
                        <div class="homing_title_text">
                          Excellent Design Capability
                        </div>
                        <div class="border-diver"></div>
                      </div>
                      <div class="homing_item_content">
                        HOMING is a class A interior design firm with more than
                        20 years of experience and many experienced designers,
                        project managers and engineers. We also work in close
                        collaboration with our world-renowned Italian furniture
                        design team. The passion and day-to-day commitment of
                        both teams are refected in the quality.
                      </div>
                    </div>
                    <div class="col-grid-4 no-margin">
                      <div class="homing_item">
                        <div class="homing_title_text">
                          Rich Construction Experience
                        </div>
                        <div class="border-diver"></div>
                      </div>
                      <div class="homing_item_content">
                        Over the decades, our focus on interior design has
                        resulted in a wealth of construction experience. We have
                        also mastered the art of construction technology and
                        nurtured excellent management and engineering teams.
                        Using our technology and expertise, we have also worked
                        on many overseas projects to great success.
                      </div>
                    </div>
                    <div class="col-grid-4 no-margin">
                      <div class="homing_item">
                        <div class="two_row_item">
                          High Standards In Quality Management And Assurance
                        </div>
                        <div class="border-diver"></div>
                      </div>
                      <div class="homing_item_content">
                        The success of each project is dependent on its
                        successful management. Since our inception, we have
                        established and developed strict quality management
                        processes and implemented the ISO international standard
                        for quality management and quality assurance. and
                        elegance of every piece of furniture we produce for you.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- 多图片展示 -->
              <div class="homing_images">
                <div class="img_row_two">
                  <div>
                    <img src="../assets/images/homing/1.png" />
                  </div>
                  <div>
                    <img src="../assets/images/homing/2.png" />
                  </div>
                </div>
                <div class="img_row_more">
                  <div>
                    <img src="../assets/images/homing/3.png" />
                  </div>
                  <div>
                    <img src="../assets/images/homing/4.png" />
                  </div>
                  <div>
                    <img src="../assets/images/homing/5.png" />
                  </div>
                  <div>
                    <img src="../assets/images/homing/6.png" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <main-foot></main-foot>
    <PageScroller></PageScroller>
  </div>
</template>

<script>
import MainHeader from "../components/MainHeader";
import MainFoot from "../components//MainFoot";
import PageScroller from "../components/PageScroller";

export default {
  name: "HomingSeries",
  created() {
    let self = this;
  },
  data() {
    return {};
  },
  methods: {
    nextHoming() {
      window.open("http://www.homing.sg");
    },
  },
  components: { MainHeader, MainFoot, PageScroller },
};
</script>

<style lang="less"  scoped>
.p_logo {
  position: relative;
  bottom: 5px;
}
.homing_images {
  display: flex;
  flex-direction: column;
  margin-bottom: 90px;
  .img_row_two {
    display: flex;
    margin-bottom: 10px;
    flex-wrap: wrap;
    > div {
      flex: 1;
      img {
        width: 100%;
      }
    }
    > div:first-child {
      margin-right: 10px;
    }
  }
  .img_row_more {
    display: flex;
    flex-wrap: wrap;
    > div {
      margin-right: 10px;
      flex: 1;
      img {
        width: 100%;
      }
    }
    > div:last-child {
      margin-right: 0;
    }
  }
}
.homing_section {
  margin-bottom: 0;
  padding-top: 90px;
  padding-bottom: 90px;
  clear: both;
}
.homing_bg {
  img {
    width: 100%;
  }
}
.paddingLeft {
  a {
    margin-bottom: 50px;
  }
}
.homing_item {
  margin-bottom: 30px;
  .homing_title_text,
  .two_row_item {
    font-size: 20px;
    color: #000000;
  }
  .homing_title_text {
    margin-bottom: 50px;
  }
  .border-diver {
    width: 80px;
    height: 3px;
    background-color: #e81f20;
  }
}
.two_row_item {
  margin-bottom: 20px;
}
.more {
  -webkit-transition: all 0.3s ease 0s;
  transition: all 0.3s ease 0s;
  background: #e81f20;
  border-radius: 50px;
  color: #fff;
  font-size: 14px;
  line-height: 1.8;
  padding: 10px 35px;
  border: none;
  height: auto;
  width: auto;
  cursor: pointer;
  display: inline-block;
  min-width: 135px;
  text-align: center;
  position: relative;
  top: 80px;
  &:hover {
    background-color: #222;
    color: #fff;
    -webkit-box-shadow: 0px 2px 7px 0px rgba(162, 160, 160, 0.54);
    box-shadow: 0px 2px 7px 0px rgba(162, 160, 160, 0.54);
  }
}
.dividerRed {
  &:before {
    width: 60px;
    height: 3px;
    margin-left: 17px;
    content: "";
    display: block;
    background: #e81f20;
    margin: 5px auto;
  }
}
.divider0,
.dividerRed {
  height: 3px;
  width: 100px;
  margin: 0 0 15px;
  position: relative;
  display: inline-block;
  border-bottom: 3px solid #e81f20;
}
</style>
